var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChartContainer',{attrs:{"title":_vm.title}},[_c('BaseChart',{attrs:{"options":_vm.options,"width":_vm.width,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }